import MutualFundOrderBookRepository from "@adapters/features/ActivityBook/OrderBook/MutualFund/Repository/MutualFundOrderBookRepository";
import { EdelFileSaver } from "@domains/utils/FIleSaver";
import ClientRepository from "@adapters/salesFeatures/Clients/repositories/Clients";
export default (function (http, salesHttp) {
    return {
        mutualFundOrderBook: new MutualFundOrderBookRepository(http, new EdelFileSaver(), salesHttp),
        clients: new ClientRepository(http),
    };
});
